import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e9fcfadb: FaireBrandEntity = {
  token: "b_e9fcfadb",
  type: "brand",
  name: "GP Candle Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/d0b07851c2f276e23b0b987b24bba469b1e21a75895fb9002f96f529b3b6603f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e7b5915f5e950a6c791cfe52e8d9218b7ae4ef2a735999706c12dc14271a8a8b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d0b07851c2f276e23b0b987b24bba469b1e21a75895fb9002f96f529b3b6603f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e7b5915f5e950a6c791cfe52e8d9218b7ae4ef2a735999706c12dc14271a8a8b.jpeg",
  location: "Philadelphia, PA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 54,
  isTopShop: true,
  isInsider: true,
  description:
    "We make good candles for good people.\n\nFounded in 2012 as Greenmarket Purveying Co., our company began as an adventure to capture and celebrate fine home fragrance and its powerful connection to memory.\n\nWe craft our candles and reed diffusers to smell amazing, be aesthetically beautiful, clean-burning, and mindfully sourced. We use a US-grown, non-GMO soy wax blend, high quality naturally derived fragrances, and cotton wicks. We’ve designed our vessels and packaging to be recyclable or reusable. Our fragrances are vegan, free of phthalates and parabens, and cruelty-free.\n\nNow owned by some of the artists and makers who helped grow the company over the years, GP Candle Co. is proudly a women-owned and operated business. We create all of our products by hand in our studio just outside of Philadelphia, Pennsylvania.\n\nOur products are bold and bright, and feature colorful scents to fit your mood. Every product ignites a spark of joy and purpose. Our whimsical designs and sweet fragrances are crafted to bring light and warmth into your home. Plus, each purchase supports causes close to our hearts.\n\nWe think it's important to use our business to make a positive impact on the world. That's why we're excited to announce that we've started donating a part of our proceeds to charities.\n\nThanks for being a part of our mission to do good!\n\nWith love,\nGP Candle Co.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:43.522Z",
    importedBy: "entity-db-cli",
  },
};
